import { render, staticRenderFns } from "./ReceiptDetailHonobonoInfo.vue?vue&type=template&id=535c6f2a&"
import script from "./ReceiptDetailHonobonoInfo.vue?vue&type=script&lang=ts&"
export * from "./ReceiptDetailHonobonoInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports